import Cube from '@phosphor-icons/core/assets/light/cube-light.svg?component-solid';
import { Motion } from 'solid-motionone';

import { useTheme } from 'framework';

import classes from './loaders.module.css';

export const LoadIcon = (props) => {
  const theme = useTheme();
  return (
    <Motion.div
      animate={{
        rotate: 360,
      }}
      transition={{ duration: 2, repeat: Infinity, easing: 'linear' }}
    >
      <Cube
        {...props}
        width={props.size || 12}
        height={props.size || 12}
        stroke={props.stroke || 1}
        color={theme.primaryColor}
      ></Cube>
    </Motion.div>
  );
};

export const LoadSplash = (props) => {
  return (
    <div className={classes.splashWrapper}>
      <div className={classes.splashContent}>
        {!!props.image && (
          <img src={props.image} className={classes.splashImage} />
        )}
        <div className={classes.splashIcon}>
          <LoadIcon size={64} stroke={1} />
        </div>
      </div>
    </div>
  );
};

export const LoadOverlay = (props) => {
  return (
    <div className={classes.overlay}>
      <LoadSplash {...props} />
    </div>
  );
};

export const LoadSpinner = (props) => {
  const size = props.size || 40;
  return (
    <span
      className={classes.spinner}
      style={{
        'border-width': `${props.stroke || size / 10}px`,
        width: `${size}px`,
        height: `${size}px`,
      }}
    ></span>
  );
};
